export default "__VITE_PUBLIC_ASSET__d0b6da73__"